/* Ruby Rose — hero headline line justification.

   The artboard stretches every headline line out to the same measure: "Without"
   sits at its natural tracking and sets the width, "Beauty" is tracked +0.086em
   and "Limits" +0.193em to reach it. That is what makes the block read as an
   evenly balanced column instead of a left-ragged one.

   CSS cannot express it. `text-align: justify` distributes at word spaces and
   these lines are single words, and `text-justify: inter-character` — which
   would distribute between glyphs — is not supported in Chrome. So the lines
   are measured after layout and tracked individually.

   The text is left untouched in the DOM until this runs, so the headline still
   renders (un-tracked) if scripting is off. */

(function () {
  if (window.__rrHeroJustify) return;
  window.__rrHeroJustify = true;

  var SELECTOR = "[data-rr-justify]";

  /* The even-measure composition belongs to the desktop layout the artboard
     describes. Below it the panel is full width and wraps differently — at
     375px the heading becomes "Beauty" / "Without Limits", where matching the
     measure would mean tracking "Beauty" by 0.76em. */
  var DESKTOP = window.matchMedia("(min-width: 1024px)");

  /* Sanity ceiling. The artboard's widest correction is 0.193em, so anything
     past this means the lines are too unlike each other for justification to
     read as deliberate, and the heading is better left ragged. */
  var MAX_TRACKING_EM = 0.25;

  /* Where did the browser actually break this text? Walk the characters and
     watch for the line box top changing. Characters that collapse at a break
     report no rect at all, hence the length check. */
  function linesOf(el, text) {
    var node = el.firstChild;
    if (!node) return [];

    var range = document.createRange();
    var out = [];
    var start = 0;
    var previousTop = null;

    for (var i = 0; i < text.length; i++) {
      range.setStart(node, i);
      range.setEnd(node, i + 1);

      var rects = range.getClientRects();
      if (!rects.length) continue;

      var top = Math.round(rects[0].top * 10) / 10;
      if (previousTop === null) previousTop = top;

      if (Math.abs(top - previousTop) > 1) {
        out.push(text.slice(start, i));
        start = i;
        previousTop = top;
      }
    }
    out.push(text.slice(start));

    return out
      .map(function (line) { return line.trim(); })
      .filter(function (line) { return line.length > 0; });
  }

  /* One line box, with its final character isolated so that character's
     trailing letter-space can be zeroed. Without that the span runs one full
     tracking step wider than its own ink and can overflow the column. */
  function buildLine(text) {
    var span = document.createElement("span");
    span.className = "rr-hero__line";
    span.appendChild(document.createTextNode(text.slice(0, -1)));

    var tail = document.createElement("span");
    tail.className = "rr-hero__line-tail";
    tail.textContent = text.slice(-1);
    span.appendChild(tail);

    return span;
  }

  /* The subheading is a richtext field, so the attribute sits on the wrapper
     while the text lives in the <p> Shopify emits inside it. Step through a
     lone wrapper to reach whatever actually holds the words. */
  function textHost(el) {
    var host = el;
    while (
      host.children.length === 1 &&
      !host.children[0].classList.contains("rr-hero__line") &&
      host.textContent.trim() === host.children[0].textContent.trim()
    ) {
      host = host.children[0];
    }
    return host;
  }

  function justify(el) {
    var text = el.getAttribute("data-rr-text");

    /* Rebuilding from textContent flattens any markup inside. On the first run
       that would silently destroy a merchant's bold or link, so leave anything
       that is not plain text alone. Later runs legitimately see our own spans. */
    if (text === null && el.children.length > 0) return;

    if (text === null) {
      text = el.textContent.replace(/\s+/g, " ").trim();
      el.setAttribute("data-rr-text", text);
    }
    if (!text) return;

    // Always start from the plain text: a new width means a new natural wrap.
    el.textContent = text;
    if (!DESKTOP.matches) return;

    var parts = linesOf(el, text);
    // A single line has nothing to be flush with.
    if (parts.length < 2) return;

    var probe = document.createRange();
    var spans = parts.map(function (line) {
      return el.appendChild(buildLine(line));
    });

    // Measured off the text, not the box: the spans are block-level so their
    // boxes all fill the column, which would make every line "the widest".
    el.removeChild(el.firstChild);
    var widths = spans.map(function (span) {
      probe.selectNodeContents(span);
      return probe.getBoundingClientRect().width;
    });
    var measure = Math.max.apply(null, widths);
    var size = parseFloat(getComputedStyle(el).fontSize) || 1;

    var tracking = spans.map(function (span, i) {
      // letter-spacing lands after every character, so N characters open N-1
      // gaps between them; the last one's trailing space is zeroed in CSS.
      var gaps = parts[i].length - 1;
      return gaps < 1 ? 0 : (measure - widths[i]) / gaps;
    });

    var worst = Math.max.apply(null, tracking);
    if (worst / size > MAX_TRACKING_EM) {
      el.textContent = text;
      return;
    }

    spans.forEach(function (span, i) {
      if (tracking[i] > 0) span.style.letterSpacing = tracking[i].toFixed(3) + "px";
    });
  }

  function run() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) justify(textHost(nodes[i]));
  }

  /* Tracking is derived from measured glyph widths, so it has to wait for the
     real face — running against the fallback bakes in the wrong numbers. */
  function boot() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    } else {
      run();
    }
  }

  var frame = 0;
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(run);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener("resize", schedule);
  document.addEventListener("shopify:section:load", run);

  if (DESKTOP.addEventListener) DESKTOP.addEventListener("change", schedule);
  else if (DESKTOP.addListener) DESKTOP.addListener(schedule);
})();
